<template>
  <section class="c parking-lot-creation" :class="[{'is-open': open}, {'is-absolute': absolute}]">
    <form @submit.prevent="create()">
      <v-card>
        <v-card-title>
            <h3 class="headline">Standort erstellen</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 v-if="err">
              <v-alert
                :value="true"
                :type="err.type"
              >
                {{ err.msg }}
              </v-alert>
            </v-flex>
            <v-flex xs12 v-if="createMode === 'draw'">
              Zeichnen Sie auf der Karte die Parkfläche ein!
            </v-flex>
            <v-flex xs12 v-else>
              Zeichnen Sie den Standort der Fläche auf der Karte ein, in dem Sie
              den Punkt an die richtige Stelle ziehen!
            </v-flex>
            <v-flex xs12 v-if="deviceFolder">
              <v-autocomplete
                v-model="form.tag_id"
                :items="folders"
                label="Geräte-Ordner (aus element-iot)*"
                prepend-icon="folder"
                item-text="name"
                item-value="id"
                :required="deviceFolder"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="missingDevices">
              <v-autocomplete
                v-model="form.device_id"
                :items="devices"
                label="Gerät zuweisen (aus element-iot)*"
                prepend-icon="devices"
                item-text="name"
                item-value="id"
                :required="missingDevices"
                @change="deviceSelected"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="hasName">
              <v-text-field
                label="Name*"
                v-model="form.name"
                :required="hasName"
              ></v-text-field>
            </v-flex>
            <slot></slot>
            <v-flex xs12 v-if="hint">
              Sie haben noch keinen Ordner erstellt?
              <a :href="$variables.elementLinks.createFolder" target="_blank">Jetzt erstellen.</a>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="toggle">Abbrechen</v-btn>
          <v-btn color="primary" type="submit">Erstellen</v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </section>
</template>

<script>
export default {
  name: 'parking-lot-creation',

  props: {
    absolute: {
      type: Boolean,
      default: false,
    },
    geoJson: {
      type: Object,
    },
    deviceFolder: {
      type: Boolean,
      default: true,
    },
    missingDevices: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: Boolean,
      default: false,
    },
    hasName: {
      type: Boolean,
      default: true,
    },
    createMode: {
      type: String,
      default: 'draw',
    },
  },

  data() {
    return {
      open: false,
      form: {
        name: '',
        tag_id: '',
        device_id: '',
      },
      err: null,
    };
  },

  computed: {
    folders() {
      return this.$store.folders.state.folders;
    },
    devices() {
      return this.$store.devices.state.devices;
    },
  },

  methods: {
    deviceSelected(device_id) {
      // TODO: solve this properly without this hackyhack to set the device's name in the form
      var device = this.devices.find(device => {
        return device.id == device_id
      });
      this.form.name = device.name
    },
    toggle() {
      if (this.open) {
        this.form = {
          name: '',
          tag_id: '',
          device_id: '',
        };
        this.$emit('close');
      }
      this.open = !this.open;
      this.$store.folders.dispatch('GET_FOLDERS');
    },
    showError(msg, type) {
      this.err = { msg, type };
    },
    create() {
      console.log(this.geoJson);
      if (this.geoJson) {
        this.form.shape = this.geoJson;
        this.$emit('save', this.form);
        this.toggle();
      } else {
        this.showError('Sie müssen eine Fläche auf der Karte einzeichnen!', 'error');
      }
    },
  },
};
</script>
